import React from "react";
import ProductsCategoryCard from "./ProductsCategoryCard";

const ProductsSection = ({ title, description }) => {
  return (
    <div className="products-section">
      <div className="grid lg:grid-cols-2 grid-cols-1 px-[16px] md:px-[24px] gap-x-[42px] gap-y-[24px] md:gap-y-[35px] my-[24px] md:my-[16px] lg:my-[35px] max-w-[1241px] m-auto lg:px-0">
        <ProductsCategoryCard
          title="Trending Products"
          description="Discover the newest trends in our curated collection of trending products"
          tags="trending"
        />
        <ProductsCategoryCard
          title="New Arrivals"
          description="Buy From An Exciting Collection Of Our Newly Added Products"
          tags="new"
        />
        <ProductsCategoryCard
          title="MOQ Products"
          description="Find Product From Certified Low MOQ Manufacture & Wholesale Supplier"
          tags="moq"
        />
        <ProductsCategoryCard
          title="OEM Products"
          description="Reliable OEM companies offering thousands of popular OEM parts & items"
          tags="oem"
        />
      </div>
    </div>
  );
};

export default ProductsSection;
